import { getConfig,getUserInfo } from "./auth";
import { getToken, getUserId } from '@/utils/auth';
import md5 from 'crypto-js/md5';
import { codeToText } from "element-china-area-data";

//加密平台标识
const OS = 'web';

//加密盐
const SALT = 'emhhHaC';

//获取请求头
export const getHeader = () => {
    const timeStamp = Date.now() + '';
    const sign = '01' + md5(timeStamp + SALT);
    let obj = {
        'os': OS,
        'x-time': timeStamp,
        'x-sign': sign,
    };
    if (getToken()) {
        obj['token'] = getToken();
    }
    if (getUserId()) {
        obj['userId'] = getUserId();
    }
    if(getUserInfo()){
        obj['level'] = getUserInfo().level;
    }
    return obj;
}

//上传图片地址
export const uploadUrl = 'https://api.zhgylgl.com/api/uploadImg';

//获取公共数据列表
export const publicList = () => {
    let globalInfo = getConfig();
    if (!globalInfo) return {};
    let carLong, carType, goodsType, unit; //目前用到四个公共数据 车长 车型 货物类型 货物单位

    carType = globalInfo.carType;
    unit = globalInfo.unit;
    goodsType = globalInfo.goodsType.map(item => ({
        name: item,
        key: item
    }));
    carLong = globalInfo.carLong.map(item => ({
        name: item,
        key: item
    }));

    return {
        carLong,
        carType,
        goodsType,
        unit,
        validityPeriodTime: globalInfo.validityPeriodTime
    };
}



//把区域码转成汉字
export const getCodeToText = (codeArray) => {
    let area = [];
    switch (codeArray.length) {
        case 1:
            area.push(codeToText[codeArray[0]])
            break;
        case 2:
            area.push(codeToText[codeArray[0]])
            area.push(codeToText[codeArray[1]])
            break;
        case 3:
            area.push(codeToText[codeArray[0]])
            area.push(codeToText[codeArray[1]])
            area.push(codeToText[codeArray[2]])
            break;
        default:
            break;
    }
    return area;
}

//抹零方法
export const handleMoney = (num) => {
    num = Number(num);
    if (isNaN(num)) return 0;//用户输入的不是数字返回0
    //首先取整
    num = parseInt(num);
    //向下取整抹零
    let restNum = num % 10
    num = num - restNum;
    //返回数字带两位小数
    return num.toFixed(2);
}

//深克隆方法
export const deepClone = (obj) => {
    let objClone = Array.isArray(obj) ? [] : {};
    if (obj && typeof obj === "object") {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                //判断ojb子元素是否为对象，如果是，递归复制
                if (obj[key] && typeof obj[key] === "object") {
                    objClone[key] = deepClone(obj[key]);
                } else {
                    //如果不是，简单复制
                    objClone[key] = obj[key];
                }
            }
        }
    }
    return objClone;
}


//下载后端返回的文件
export const downloadFile = (url) => {
    var oReq = new XMLHttpRequest();
    // The Endpoint of your server
    const fileName = (url + '').replace('http://img.zhgylgl.com/', '');
    var URLToPDF = url;
    // Configure XMLHttpRequest
    oReq.open("GET", URLToPDF, true);
    // Important to use the blob response type
    oReq.responseType = "blob";
    // When the file request finishes
    // Is up to you, the configuration for error events etc.
    oReq.onload = function () {
        // Once the file is downloaded, open a new window with the PDF
        // Remember to allow the POP-UPS in your browser
        var file = new Blob([oReq.response], {
            type: "application/pdf"
        });
        // Generate file download directly in the browser !
        // saveAs(file, "mypdffilename.pdf");
        saveAs(file, decodeURIComponent(fileName));
    };
    oReq.send();
}
//与上次记录的时间戳对比
export const diffLastTimeStamp = () => {
    let time = 60 * 8;//分钟为单位
    let lastTimestamp = sessionStorage.getItem("lastTimestamp");
    sessionStorage.setItem("lastTimestamp", Date.now());
    if (lastTimestamp && !isNaN(lastTimestamp)) {
        lastTimestamp = Number(lastTimestamp);
        let current = Date.now();
        if (current - lastTimestamp > (time * 60 * 1000)) {
            return true;
        }
    }
}

//将对象格式转换为params参数123
export function convertObjectToQueryString(obj) {
    let queryString = '';
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (key == 'time' || key == 'th_time') {
                if (obj[key]) {
                    queryString += key + '=' + obj[key].join('/') + '&';
                }
            } else if (key == 'reach_time') {
                if (obj[key]) {
                    queryString += key + '=' + obj[key].join(' - ') + '&';
                }
            }
            else {
                queryString += key + '=' + obj[key] + '&';

            }
        }
    }
    return queryString.slice(0, -1);
};